// extracted by mini-css-extract-plugin
module.exports = {"header":"_1ZFNDGyPfYMnn47oYpHptl","avatar":"_23OAUtflt5qeGN2ks32mF9","title":"y2fTYjooV3LlHVASLRbHV","value":"_1a2DGog2NGJmDyuFlorFf5","closeIcon":"YuZtRCLXtucfTJBuJItU3"};